import CdRatesQuery from '@/app_gql/widgets/RedVentures/GetCDRatesQuery.gql';
import { GetData } from '@/app_lib/getData';
import { CdRatesResponse, type RatesData } from '../utils';
import type { RatesApiParameters } from '../../../_lib/utils/widgets/redVenturesConstants';

export async function getCdRates({
  depositAmount,
  page,
  minTermLength = 1,
  maxTermLength = 1,
  pageSize,
  zip,
}: RatesApiParameters): Promise<RatesData[]> {
  const productTerm = Array.from({ length: maxTermLength - minTermLength + 1 }, (__, i) => i + minTermLength);
  const listingType = 'ALL';
  const ignoreBudget = false;
  const pid = 'myfi_fortune_api';

  const body = {
    zip,
    ...(page && { page }),
    ...(pageSize && { pageSize }),
    depositAmount,
    ignoreBudget,
    listingType,
    pid,
    productTerm,
  };

  const data = await GetData.redVentures<CdRatesResponse>(CdRatesQuery, body);

  if (!data.success) {
    throw new Error(`HTTP Error: ${data}`);
  }
  const validatedData = CdRatesResponse.safeParse(data.value);
  if (!validatedData.success) {
    throw new Error(`Validation Error: ${validatedData.error}`);
  }
  return validatedData.data.cd_rates;
}
